export default __webpack_public_path__ + "static/learn-cover2-eb8d8f1fbe69744b95b40389c93d8486.jpg";